import { specProgReqActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [specProgReqActions.loadSuccess]: (state, action) => {
        return action.payload.entities.specProgReqMsgs;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        let result;
        result = action.payload.specProgReqMsgs.entities.specProgReqMsgs ? action.payload.specProgReqMsgs.entities.specProgReqMsgs : {};
        return result;
    },
    [specProgReqActions.replySuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.nosxno === action.payload) {
                delete state[x.nono];
            }
        })
    },
    [specProgReqActions.markReadSuccess]: (state, action) => {
        state[action.payload].isRead = true;
    },


})


